<!--
    描述：快捷菜单子菜单--- 首页
    时间：2021-03-26
    Created by 王帅
-->
<template>
    <div class="home-main">
        <!-- 上方 -->
        <div class="home-top">
            <div class="top-box" v-for="(item, index) in topList" :key="'top' + index"
                 @click="jumpMenu(item)">
                <div class="icon-box">
                    {{ item.iconName }}
                    <el-tooltip placement="bottom-start" effect="light">
                        <div slot="content" class="tootip-content">
                            <h6>{{ item.title1 }}</h6>
                            <p>{{ item.desc1 }}</p>
                            <h6>{{ item.title2 }}</h6>
                            <p>{{ item.desc2 }}</p>
                        </div>
                        <svg-icon class="mt5" icon-class="wenhao"></svg-icon>
                    </el-tooltip>
                </div>
                <div class="title-box">
                    <p class="text-overflow">
                        <span
                            ><b class="fontSize" :style="smallText(topObj[item.key1])"
                                >{{ topObj[item.key1] }} </b
                            >({{ item.unit }})</span
                        ><br />
                        <span>{{ item.special ? item.shwoTitle1 : item.title1 }}</span>
                    </p>
                    <span class="divider"></span>
                    <p class="text-overflow">
                        <span
                            ><b class="fontSize" :style="smallText(topObj[item.key2])"
                                >{{ topObj[item.key2] !== undefined ? topObj[item.key2] : '-' }} </b
                            >({{ item.unit }})</span
                        ><br />
                        <span>{{ item.special ? item.shwoTitle2 : item.title2 }}</span>
                    </p>
                </div>
            </div>
        </div>

        <!-- 下方 card -->
        <div class="home-content">
            <div
                class="card-box"
                v-for="(item, index) in cardList.slice(0, 2)"
                :key="'card1' + index"
            >
                <div class="card-header">
                    <span class="header-title">{{ item.title }} 
                        <!-- 审计动态添加辅助文字 -->
                        <el-tooltip
                            class="header-icon"
                            effect="light"
                            v-if="index === 0"
                            placement="right-start"
                        >
                            <div slot="content">
                                审计动态： 当用户进行创建项目、项目报审、<br />委托协审、委托撤回、委托任务作废、项目<br />退审、委托受理等，首页都会显示相关动态<br />信息。
                            </div>
                            <svg-icon class="wenhao" icon-class="wenhao"></svg-icon>
                        </el-tooltip>
                    </span>
                    <div class="header-more" @click="handleMore(item, index)">
                        更多 >>
                    </div>
                </div>
                <div class="card-content">
                    <!-- 第一个 -->
                    <template v-if="index === 0">
                        <div
                            class="card-row text-overflow"
                            v-for="(m, n) in item.dataList"
                            :key="'数据' + index + n"
                            @click="handleAudit(m)"
                        >
                            <div class="text-overflow title-width">
                                {{ `【${m.issues}】` }}
                            </div>
                            <div class="text-overflow content-width">
                                <el-tooltip
                                    :content="m.content"
                                    :disabled="m.content.length < 20"
                                    placement="bottom-start"
                                    popper-class="max-tooltip"
                                    :open-delay="300"
                                >
                                    <div class="text-overflow">{{ m.content }}</div>
                                </el-tooltip>
                            </div>
                            <div class="text-overflow company-width">
                                <el-tooltip
                                    :content="m.companyName"
                                    popper-class="max-tooltip"
                                    placement="bottom-start"
                                    :open-delay="300"
                                >
                                    <span class="text-overflow">{{
                                        m.companyShortName
                                            ? m.companyShortName.slice(0, 8)
                                            : ""
                                    }}</span>
                                </el-tooltip>
                            </div>
                            <div class="text-overflow sname-width">
                                <el-tooltip
                                    :content="m.userName"
                                    popper-class="max-tooltip"
                                    placement="bottom-start"
                                    :open-delay="300"
                                >
                                    <span class="text-overflow">{{ m.userName }}</span>
                                </el-tooltip>
                            </div>
                            <div class="text-right text-overflow date-width">
                                <el-tooltip
                                    :content="m.createDate"
                                    popper-class="max-tooltip"
                                    placement="bottom-start"
                                    :open-delay="300"
                                >
                                    <span class="text-overflow">{{
                                        m.createDate ? m.createDate.slice(0, 10) : ""
                                    }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>

                    <!-- 第二个card -->
                    <template v-else>
                        <div
                            class="card-row text-overflow"
                            v-for="(m, n) in item.dataList"
                            :key="'数据' + index + n"
                            @click="handleNotice(m)"
                        >
                            <div class="text-overflow title-width">
                                <svg-icon
                                    :icon-class="m.readFlag ? 'Readed' : 'Unread'"
                                    :class="m.readFlag ? 'readed-color' : 'unread-color'"
                                ></svg-icon
                                >【系统通知】
                            </div>
                            <div class="text-overflow content-width">
                                <div class="level-sname">
                                    <el-tooltip
                                        :content="m.sname"
                                        popper-class="max-tooltip"
                                        placement="bottom-start"
                                        :disabled="m.sname.length < 15"
                                    >
                                        <div class="text-overflow">{{ m.sname }}</div>
                                    </el-tooltip>
                                    <span class="level-text">
                                        <svg-icon
                                            icon-class="yiban"
                                            v-if="m.level === 1"
                                        ></svg-icon>
                                        <svg-icon
                                            icon-class="zhongyao"
                                            v-if="m.level === 2"
                                        ></svg-icon>
                                        <svg-icon
                                            icon-class="jinji"
                                            v-if="m.level === 3"
                                        ></svg-icon>
                                    </span>
                                </div>
                                <!-- <span
                                    class="level-text"
                                    :style="getLevelText(m.level).style"
                                    >{{ getLevelText(m.level).text }}</span
                                    
                                > -->
                            </div>
                            <div class="text-overflow sname-width">
                                {{ m.publishName }}
                            </div>
                            <div class="text-overflow text-right date-width">
                                <el-tooltip
                                    :content="m.createDate"
                                    popper-class="max-tooltip"
                                    placement="bottom-start"
                                    :open-delay="300"
                                >
                                    <span class="text-overflow">{{
                                        m.createDate ? m.createDate.slice(0, 10) : ""
                                    }}</span>
                                </el-tooltip>
                            </div>
                            <!-- <el-col :span="4" class="text-right text-overflow">
                                <span :class="m.status === 1 ? 'is-read' : 'is-unread'"></span>
                                {{ m.status === 1 ? '已读' : '未读' }}
                            </el-col> -->
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="home-content">
            <div
                class="card-box"
                v-for="(item, index) in cardList.slice(2, 4)"
                :key="'card1' + index"
            >
                <div class="card-header">
                    <span class="header-title">{{ item.title }}</span>
                    <!-- <div
                        class="header-more"
                        @click="handleMore(item, index)"
                        v-if="index === 1"
                    >
                        更多 >>
                    </div> -->
                </div>
                <div class="card-content" :style="index === 1 ? 'padding-left: 11px' : ''">
                    <template v-if="index === 0">
                        <!-- 订阅容器 -->
                        <div class="sub-container">
                            <div
                                class="sub-item"
                                v-for="(i, index) in filterResources"
                                :key="'resources' + index"
                                @click="doViewResource(i)"
                            >
                                <span class="sub-tips-icon">
                                    <i :class="i.iconName"></i>
                                </span>
                                <div class="sub-icon">
                                    <img class="sub-img" :src="i.iconUrl" alt="" />
                                </div>
                                <p class="sub-text">{{ i.sname }}</p>
                            </div>
                        </div>
                    </template>
                    <!-- 第二个card -->
                    <template v-else>
                        <div
                            class="card-row text-overflow"
                            v-for="(m, n) in item.dataList"
                            :key="'数据4' + index + n"
                            @click="goAudit(m)"
                        >
                            <div class="text-overflow title-width">
                                <svg-icon
                                    :icon-class="['1006008008', '1006008009'].includes(m.approvalType) ? 'shouli' : 'shenji'"
                                    :class="['1006008008', '1006008009'].includes(m.approvalType) ? 'shouli-color' : 'shenji-color'"
                                ></svg-icon
                                >{{ `【${m.approvalTypeName}】` }}
                            </div>
                            <div class="text-overflow content-width">
                                <el-tooltip
                                    :content="m.title"
                                    :disabled="m.title.length < 15"
                                    placement="bottom-start"
                                    popper-class="max-tooltip"
                                    :open-delay="300"
                                >
                                    <div class="text-overflow">{{ m.title }}</div>
                                </el-tooltip>
                            </div>
                            <div class="text-overflow company-width">
                                <el-tooltip
                                    :content="m.sponsorUnit"
                                    popper-class="max-tooltip"
                                    placement="bottom-start"
                                    :open-delay="300"
                                >
                                    <span class="text-overflow">{{
                                        m.sponsorUnit
                                            ? m.sponsorUnit.slice(0, 8)
                                            : ""
                                    }}</span>
                                </el-tooltip>
                            </div>
                            <div class="text-overflow sname-width">
                                <el-tooltip
                                    :content="m.createUserName"
                                    popper-class="max-tooltip"
                                    placement="bottom-start"
                                    :open-delay="300"
                                >
                                    <span class="text-overflow">{{ m.createUserName }}</span>
                                </el-tooltip>
                            </div>
                            <div class="text-right text-overflow date-width">
                                <el-tooltip
                                    :content="m.createDate"
                                    popper-class="max-tooltip"
                                    placement="bottom-start"
                                    :open-delay="300"
                                >
                                    <span class="text-overflow">{{
                                        m.createDate ? m.createDate.slice(0, 10) : ""
                                    }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <!-- 更多弹窗 -->
        <el-dialog
            :title="dialogObj.title"
            :visible.sync="dialogObj.show"
            :width="dialogObj.width"
            :close-on-click-modal="false"
            custom-class="more-dialog-home"
            center
            @close="doCancel"
        >
            <NoticeDialog
                v-if="dialogObj.show"
                ref="notice"
                :type="dialogObj.type"
                :acceptObj="selectObj"
                @tabNum="getTabNum"
            ></NoticeDialog>
            <template slot="footer">
                <el-input
                    v-model="comment"
                    v-if="tabNum == '1'"
                    class="mt10 sp-input-home"
                    maxlength="200"
                    show-word-limit
                    placeholder="请输入评论内容"
                >
                    <template slot="append">
                        <el-button
                            type="primary"
                            :loading="btnLoading"
                            @click="sendComment"
                            >发布</el-button
                        >
                    </template>
                </el-input>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import NoticeDialog from "views/NotificationManager/NoticeDialog";
import * as ApprovalApi from "api/approval/approval";
import * as NoticeApi from "api/noticeManager/index";
import * as HomeApi from "api/home/homeIndex";
import { mapState } from "vuex";

export default {
    name: "Home",
    components: {
        NoticeDialog,
    },
    data() {
        return {
            showTopDesc: false,
            topList: [
                {
                    title1: "在审项目数",
                    title2: "已审结项目数",
                    desc1: "统计正在进行审计的项目数量总和",
                    desc2: "统计已经结项的项目数量总和",
                    key1: "retrialProjectNum",
                    key2: "concludedProjectNum",
                    unit: "个",
                    icon: "",
                    iconName: "项目",
                    field: 'project',
                    special: true,
                    shwoTitle1: '在审中',
                    shwoTitle2: '已审结',
                },
                {
                    title1: "进行中任务数",
                    title2: "完成任务总数",
                    desc1: "统计正在进行的审计任务数量总数",
                    desc2: "统计已经结项的任务数量总和",
                    key1: "ongoingTaskNum",
                    key2: "concludedTaskNum",
                    unit: "个",
                    icon: "",
                    iconName: "审计任务",
                    field: 'auditTask',
                    special: true,
                    shwoTitle1: '进行中',
                    shwoTitle2: '已完成',
                },
                {
                    title1: "进行中跟踪审计",
                    title2: "进行中结算审计",
                    desc1: "根据任务类型，统计进行中的跟踪审计任务数量总和",
                    desc2: "根据任务类型，统计进行中的结算审计任务数量总和",
                    key1: "ongoingFollowUpAuditTaskNum",
                    key2: "ongoingSettlementAuditTaskNum",
                    unit: "个",
                    icon: "",
                    iconName: "任务类型",
                    field: 'taskType',
                    special: false,
                    shwoTitle1: '',
                    shwoTitle2: '',
                },
                {
                    title1: "跟踪审计合同价",
                    title2: "跟踪审计完成产值",
                    desc1: "统计跟踪审计任务（标段）中合同价的总和",
                    desc2: "统计跟踪审计任务（标段）中当前月份审核产值的完成产值总和",
                    key1: "followUpAuditContractPrice",
                    key2: "completedOutputValue",
                    unit: "万元",
                    icon: "",
                    iconName: "跟踪审计",
                    field: 'gzTask',
                    special: false,
                    shwoTitle1: '',
                    shwoTitle2: '',
                },
                {
                    title1: "结算审计合同价",
                    title2: "报审价",
                    desc1: "统计结算审计任务（标段）中合同价的总和",
                    desc2: "统计委托审计中的结算报审价总和",
                    key1: "settlementAuditContractPrice",
                    key2: "settlementauditPrice",
                    unit: "万元",
                    icon: "",
                    iconName: "结算审计",
                    field: 'jsTask',
                    special: false,
                    shwoTitle1: '',
                    shwoTitle2: '',
                },
            ],
            topObj: {
                retrialProjectNum: "",
                concludedProjectNum: "",
                ongoingTaskNum: "",
                concludedTaskNum: "",
                ongoingFollowUpAuditTaskNum: "",
                ongoingSettlementAuditTaskNum: "",
                followUpAuditContractPrice: "",
                followPercent: "",
                settlementAuditContractPrice: "",
                settlementauditPrice: "",
            },
            // card 数组
            cardList: [
                {
                    title: "审计动态",
                    dataList: [],
                },
                {
                    title: "通知公告",
                    dataList: [],
                },
                {
                    title: "订阅/资源",
                },
                {
                    title: "待办事项",
                    dataList: [],
                },
            ],
            // 资源列表
            resourcesList: [
                {
                    sname: "清单库",
                    key: "res_inventory_lib",
                    iconName: "el-icon-search",
                    iconUrl: require("@/assets/images/home/清单库@3x.png"),
                    isHave: false,
                    url: "https://www.52ngs.com/xmldata-cloud/quota/quota_search.do",
                    //'http://114.55.242.195:8280/xmldata-cloud/quota/quota_search.do'
                },
                {
                    sname: "定额库",
                    key: "res_quota_lib",
                    iconName: "el-icon-search",
                    iconUrl: require("@/assets/images/home/定额库@3x.png"),
                    isHave: false,
                    url: "https://www.52ngs.com/xmldata-cloud/newnorm/normindex.do",
                    //'http://114.55.242.195:8280/xmldata-cloud/newnorm/normindex.do'
                },
                {
                    sname: "XML解析",
                    key: "res_xml_parsing",
                    iconName: "el-icon-search",
                    iconUrl: require("@/assets/images/home/XML解析@3x.png"),
                    isHave: false,
                    url: "https://www.52ngs.com/xmlviewer/",
                    //url: 'http://114.55.242.195:8280/xmlviewer/'
                },
                {
                    sname: "风压雪压气温表",
                    key: "res_ther_table",
                    iconName: "el-icon-search",
                    iconUrl: require("@/assets/images/home/风压雪压气温表@3x.png"),
                    isHave: false,
                    url: "https://www.52ngs.com/xmldata-cloud/gb/fxlist.do",
                    //'http://114.55.242.195:8280/xmldata-cloud/gb/fxlist.do'
                },
                {
                    sname: "建筑抗震信息表",
                    key: "res_buil_seis_table",
                    iconName: "el-icon-search",
                    iconUrl: require("@/assets/images/home/建筑抗震信息表@3x.png"),
                    isHave: false,
                    url: "https://www.52ngs.com/xmldata-cloud/gb/jzkz.do",
                    //'http://114.55.242.195:8280/xmldata-cloud/gb/jzkz.do'
                },
                {
                    sname: "常用材料和构件自重表",
                    key: "res_mate_comp_table",
                    iconName: "el-icon-search",
                    iconUrl: require("@/assets/images/home/常用材料和构建自重表@3x.png"),
                    isHave: false,
                    url: "https://www.52ngs.com/xmldata-cloud/gb/clgjzz.do",
                    //'http://114.55.242.195:8280/xmldata-cloud/gb/clgjzz.do'
                },
                {
                    sname: "收费计算器 ",
                    key: "res_char_calc",
                    iconName: "el-icon-search",
                    iconUrl: require("@/assets/images/home/收费计算器@3x.png"),
                    isHave: false,
                    url: "https://www.52ngs.com/calculator-cloud/caculator/dlg.do",
                    //'http://114.55.242.195:8280/calculator-cloud/caculator/dlg.do'
                },
                // {
                // 	sname: '标书制作工具',
                // 	key: 'res_bid_make_tool',
                // 	iconName: 'el-icon-download',
                // 	iconUrl: require('@/assets/images/home/标书制作工具@3x.png'),
                // 	isHave: false,
                // 	url: 'http://47.110.33.242:8080/BSTool/login',
                // },
                // {
                // 	sname: 'CA驱动',
                // 	key: 'res_ca_drive',
                // 	iconName: 'el-icon-download',
                // 	iconUrl: require('@/assets/images/home/CA驱动@3x.png'),
                // 	isHave: false,
                // 	url:
                // 		'https://fileManage.52ngs.com/group1/2021-01-12/AIP_Setup-多浏览器.exe?name=AIP_Setup-%E5%A4%9A%E6%B5%8F%E8%A7%88%E5%99%A8.exe&download=1',
                // },
                // {
                // 	sname: '投标文件制作软件',
                // 	key: 'res_bid_doc_make_soft',
                // 	iconName: 'el-icon-download',
                // 	isHave: false,
                // 	iconUrl: require('@/assets/images/home/CA驱动@3x.png'),
                // 	url:
                // 		'https://filemanage.52ngs.com/group1/2021-01-20/文件制作工具.exe',
                // },
                // {
                //         sname: "价格信息库",
                //         key: "res_price_system",
                //         iconName: 'el-icon-search',
                //         iconUrl: require("@/assets/images/home/价格信息库@3x.png"),
                //         isHave: true,
                //         url:
                //         "https://www.52ngs.com/AnalysisProject/#/resources_management?isFromOther=true",
                //         // "http://172.16.0.14:8200/#/resources_management?isFromOther=true",
                // },
            ],
            // 弹窗对象
            dialogObj: {
                title: "", //标题
                width: "60%",
                show: false, //显隐
                type: "", //类型
                btnLoading: false,
            },
            // 通知对象
            msgForm: {
                test: "",
                test1: [],
                content: "",
            },
            selectObj: {}, //选中得编辑对象
            comment: "", //评论
            btnLoading: false,
            tabNum: "1",
        };
    },
    created() {
        this.getCardData();
        // 首页汇总top
        this.getTopData();

        // 获取通知
        this.getNoticeData();

        // 获取待审核
        this.getAuditStatusList();
    },
    methods: {
        // 获取顶部数据
        getTopData() {
            HomeApi.getHomeData({})
                .then((res) => {
                    this.topObj = res.data;
                    // this.topObj.concludedProjectNum = "--";
                    // this.topObj.concludedTaskNum = "--";
                    // this.topObj.followPercent = "--";
                })
                .catch((err) => {});
        },

        // 第一个card  伪数据
        getCardData() {
            let params = {
                issues: "", // 相关单位
                projectName: "", // 项目名称
                userId: "", // 发起人id
                deptId: "", // 发起单位
                unitType: "", // 单位类型
                projectId: "",
                current: 1, // 当前页
                size: 8, // 每页条数
            };
            this.cardList[0].dataList = [];
            HomeApi.getAuditData(params)
                .then((res) => {
                    this.cardList[0].dataList = res.data.pageList.records;
                })
                .catch((err) => {});
        },

        // 获取通知列表
        getNoticeData() {
            let params = {
                size: 8,
                current: 1,
                createUserid: this.userInfo.id,
            };
            this.cardList[1].dataList = [];
            NoticeApi.selectNoticeInfoList(params)
                .then((res) => {
                    this.cardList[1].dataList = res.data.records;
                })
                .catch((err) => {});
        },

        // 获取 待办事项 列表
        getAuditStatusList() {
            let params = {
                size: 10,
                current: 1,
                status: "1001026001", //-- --审核状态
                sname: "", //-- -- - 搜索条件
            };
            HomeApi.selectApprovalData(params)
                .then((res) => {
                    this.cardList[3].dataList = res.data;
                })
                .catch((err) => {});
        },

        // 进入待审核页面
        goAudit(item) {
            // 储存当前菜单
            let obj = {}

            // 审计管理类型
            if (item.approvalType === '1006008008') {
                obj = {
                    meta: { title: "审计管理" },
                    path: '/auditManagement',
                    name: 'AuditManagement'
                }
            } else if (item.approvalType === '1006008009') {
                // 审计任务类型
                obj = {
                    meta: { title: "审计任务" },
                    path: '/auditTask',
                    name: 'AuditTask'
                }
            } else {
                // 我的审批类型
                obj = {
                    meta: { title: "我的审批" },
                    path: "/approval",
                    name: "ApprovalIndex",
                };
            }

            if (item.approvalType == "1006008005") {
                obj.resetName = "任务结项";
            }
            item.bpaId = item.reportId;

            // 访问详情页面
            this.$setSessionItem("currentRow", JSON.stringify(item));
            // 储存当前菜单
            this.$setSessionItem("activeMenu", JSON.stringify(obj));
            // 储存当前菜单
            this.$setSessionItem("activeName", JSON.stringify("1001026001"));

            if (item.approvalType === '1006008008' || item.approvalType === '1006008009') {
                this.$setSessionItem("activeName", JSON.stringify("0"));
            }

            // 委托协审
            if (item.approvalType == "1006008002") {
                this.$router.push({
                    name: "AuditLook",
                    query: {
                        menu: "approval",
                        type: "entrust",
                        packId: item.id,
                        projectId: item.projectId,
                    },
                });
                return;
            }

            // 费用申请
            if (item.approvalType == "1006008004") {
                this.$router.push({
                    name: "FeeDialog",
                    query: {
                        menu: "approval",
                        type: "check",
                        packId: item.id,
                        projectId: item.projectId,
                    },
                });
                return;
            }

            // 任务结项
            if (item.approvalType == "1006008005") {
                this.$router.push({
                    name: "AuditLook",
                    query: {
                        menu: "approval",
                        type: "close",
                        packId: item.id,
                        projectId: item.projectId,
                    },
                });
                return;
            }

            // 审核归档信息
            if (item.approvalType == "1006008006") {
                let params = {
                    id: item.id,
                    busId: item.busId, // --任务id
                    projectId: item.projectId, // 项目id
                    packId: item.packId, // 标段id
                    statusSign: "1", //
                    auditType: item.auditType, // 审计任务类型码值
                    auditTaskArchiveSign: "1", // 这里是列表页归档按钮查询资料时传值
                    approveArchiveSign: "1", // 这里是审批查询资料时传值
                    mode: "check",
                };
                // 储存信息
                this.$setSessionItem("archiveInfo", JSON.stringify(params));

                this.$router.push({
                    name: "ArchiveInfo",
                    query: {
                        menu: "approval",
                        type: "archive",
                    },
                });
                return;
            }

            // 审计报告
			if (item.approvalType == '1006008007') {
				this.$router.push({
					name: 'ReportAudit',
					query: {
						menu: 'project',
						type: 'audit',
					},
				})
				return
			}

            // 审计管理
            if (item.approvalType == '1006008008') {
                this.$setSessionItem("activeName", JSON.stringify("0"));
                this.$router.push({
					path: '/auditManagement'
				})
				return
            }

            // 审计任务
            if (item.approvalType == '1006008009') {
                this.$router.push({
					path: '/auditTask'
				})
				return
            }

            // 审计方案
            if (item.approvalType == '1006008010') {
                this.$router.push({
					path: '/AuditPlan',
                    query: {
                        menu: "project",
                        type: "audit",
                    },
				})
				return
            }

            // 审计意见单
            if (item.approvalType == '1006008011') {
                this.$router.push({
					path: '/AuditOpinion',
                    query: {
                        menu: 'project',
                        type: 'audit',
                    },
				})
				return
            }

            // 

            // 其它
            this.$router.push({
                name: "ProjectInfoLook",
                query: {
                    menu: "approval",
                    type: "audit",
                    packId: item.id,
                    projectId: item.projectId,
                },
            });
        },

        // 跳转订阅详情
        doViewResource(item) {
            if (!item.isHave) {
                this.$message.error("暂无此按钮操作权限，请联系系统管理员！");
                return;
            }
            if (item.sname == "" || item.url == "") return;
            // 储存当前菜单
            let obj = {
                meta: this.$route.meta,
                path: this.$route.path,
                name: this.$route.name,
            };
            this.$setSessionItem("activeMenu", JSON.stringify(obj));
            if (item.key == "res_bid_make_tool") {
                //标书制作工具
                window.open("openIE:" + item.url, "_blank");
                // window.location.href = "openIE:" + item.url
            } else if (item.key == "res_ca_drive" || item.key == "res_price_system") {
                //CA驱动 或者 价格信息
                window.open(item.url, "_blank");
                // window.location.href = item.url
            } else {
                let ecItem = encodeURIComponent(JSON.stringify(item));
                this.$router.push({
                    name: "Resource-frame",
                    query: { queryItem: ecItem },
                });
            }
        },

        // 点击更多
        handleMore(item, index) {
            // 储存当前菜单
            let obj = {
                meta: this.$route.meta,
                path: this.$route.path,
                name: this.$route.name,
            };
            this.$setSessionItem("activeMenu", JSON.stringify(obj));

            if (item.title === "通知公告") {
                this.$router.push({
                    path: "/noticeMore",
                    query: {
                        type: "view",
                    },
                });
            } else if (item.title === "待办事项") {
                this.$router.push({
                    path: "/approval",
                });
            } else if (item.title === "审计动态") {
                this.$router.push({
                    path: "/auditMore",
                    query: {
                        type: "view",
                    },
                });
            }
        },

        // 查看审计动态
        handleAudit(item) {
            // 储存当前菜单
            let obj = {
                meta: this.$route.meta,
                path: this.$route.path,
                name: this.$route.name,
            };
            this.$setSessionItem("activeMenu", JSON.stringify(obj));

            this.$router.push({
                path: "/auditMore",
                query: {
                    type: "view",
                },
            });
        },

        // 查看系统通知
        handleNotice(item) {
            this.dialogObj.show = true;
            this.dialogObj.title = "系统通知";
            this.selectObj = item;
            this.dialogObj.type = "view";
        },

        // 弹窗关闭取消
        doCancel() {
            this.comment = "";
            // 弹窗关闭 重载通知
            this.getNoticeData();
        },

        // 处理通知等级文字
        getLevelText(level) {
            let msg = {
                text: "",
                style: {},
            };
            switch (level) {
                case 1:
                    msg.text = "一般";
                    msg.style.backgroundColor = "#2c8cf0";
                    break;
                case 2:
                    msg.text = "重要";
                    msg.style.backgroundColor = "#ff6600";
                    break;
                case 3:
                    msg.text = "紧急";
                    msg.style.backgroundColor = "#ff0000";
                    break;
            }
            return msg;
        },

        // 是否展示小文字
        smallText(text) {
            let style = {};
            if (text && text !== "") {
                let length = text.toString().length;

                if (length > 4) {
                    style = {
                        fontSize: "12px",
                    };
                }
            }

            return style;
        },

        // 获取tab
        getTabNum(data) {
            this.tabNum = data;
        },

        // 发送评论
        sendComment() {
            if (this.comment.trim() === "") {
                this.$message.warning("请输入评论内容！");
                return;
            }
            this.btnLoading = true;
            NoticeApi.makeCommentForNotice({
                createUserid: this.userInfo.id,
                noticeId: this.selectObj.id,
                content: this.comment,
            })
                .then((res) => {
                    this.btnLoading = false;
                    this.comment = "";
                    this.$refs.notice.getCommentList();
                })
                .catch((err) => {
                    this.btnLoading = false;
                });
        },

        // 顶部跳转
        jumpMenu(row) {
            let limitId = JSON.parse(this.$getSessionItem('limitId'))
            if (row.field == 'project') {
                this.$router.push({ path: '/projectManagement' })
                return
            } else {
                // 建设单位
                if (limitId == '1382233551767498754') {
                    this.$router.push({ path: '/commission' })
                    return
                }
                if (limitId == '1382233532112990209' || limitId == '1382233569480044661') {
                    this.$setSessionItem('activeName', JSON.stringify('1'))
                    if (row.field == 'gzTask') { 
                        this.$setSessionItem('contractPrice', 'contractPrice')
                        this.$setSessionItem('completedOutputValue', 'completedOutputValue')
                    }
                    if (row.field == 'jsTask') { 
                        this.$setSessionItem('contractPrice', 'contractPrice')
                        this.$setSessionItem('settlementAuditPrice', 'settlementAuditPrice')
                        this.$setSessionItem('completedOutputValue', 'completedOutputValue')
                    }
                }
                // 审计中心
                if (limitId == '1382233532112990209') {
                    this.$router.push({ path: '/auditManagement' })
                    return
                }
                // 协审单位
                if (limitId == '1382233569480044661') {
                    this.$router.push({ path: '/auditTask' })
                    return
                }
            }
            
        }
    },
    computed: {
        ...mapState("user", {
            userInfo: (state) => state.userInfo,
        }),
        ...mapState("menu", {
            roleBtns: (state) => state.roleBtns,
        }),

        // 根据按钮权限 筛选过后的  资源数组
        filterResources() {
            let arr = this.resourcesList;
            this.roleBtns.map((x) => {
                let _item = arr.find((y) => y.key === x);
                if (_item) {
                    _item.isHave = true;
                }
            });
            return arr;
        },
    },
};
</script>

<style scoped lang="less">
.home-main {
    height: 100%;
    background-color: #f0f2f5;
    display: flex;
    flex-direction: column;

    .home-top {
        height: 14%;
        display: flex;
        justify-content: space-between;

        .top-box {
            display: flex;
            align-items: center;
            width: 20%;
            height: 100%;
            margin-right: 10px;
            color: #fff;
            background: url("../../assets/images/home_top_bg.png") no-repeat;
            background-size: 100% 100%;
            border-radius: 5px;
            overflow: hidden;
        }

        .top-box:last-child {
            margin-right: 0;
        }

        // .content {
        //     display: flex;
        //     align-items: center;
        //     justify-content: center;
        //     overflow: hidden;
        //     width: 70%;
        //     height: 72%;
        //     border-bottom: 4px solid #a4b6fd;
        //     border-radius: 0 0 2px 2px;
        // }

        .icon-box {
            height: 100%;
            width: 40px;
            background-color: #77b9fa;
            flex-shrink: 0;
            padding: 7px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            cursor: pointer;
        }

        .title-box {
            font-size: 12px;
            flex: 1;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
        }

        .title-box span {
            display: inline-block;
            line-height: 24px;
        }

        .divider {
            display: inline-block;
            width: 0;
            border-left: 2px solid #008bf9;
            border-right: 2px solid #85bbff;
            height: 66%;
            margin: 0 15px;
        }

        .fontSize {
            font-size: 24px;
        }
    }

    .home-content {
        flex: 1;
        display: flex;
        margin-top: 10px;
        height: 30%;
        width: calc(~'100% - 10px');
        // flex-wrap: wrap;
    }

    .card-box {
        width: 50%;
        height: 100%;
        margin-right: 10px;
        // border: 1px solid #000;
        background-color: #fff;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        color: #202020;
        flex-shrink: 0;

        &:last-child {
            margin-right: 0;
        }

        .card-header {
            height: 55px;
            line-height: 55px;
            border-bottom: 1px solid #eee;
            position: relative;
        }

        .header-title {
            display: inline-block;
            font-size: 14px;
            line-height: 35px;
            width: 120px;
            background-color: #60adf9;
            border-radius: 0px 15px 15px 0px;
            padding-left: 20px;
            color: #fff;
        }

        .header-icon {
            margin-left: 10px;
            color: #666;
            font-size: 20px;
            vertical-align: middle;
        }

        .header-more {
            position: absolute;
            right: 10px;
            top: 0;
            bottom: 1px;
            background-color: #fff;
            font-size: 12px;
            color: #60adf9;
            cursor: pointer;
        }

        .card-content {
            flex: 1;
            overflow-y: hidden;
            padding: 15px;
        }

        .card-row {
            line-height: 35px;
            cursor: pointer;
            display: flex;
        }

        .card-row:hover {
            color: #58a3f7;
        }

        .no-hover {
            cursor: unset;
        }
        .no-hover:hover {
            color: unset;
        }

        .no-cursor {
            cursor: unset;
        }

        // 固定宽度
        .title-width {
            width: 120px;
            flex-shrink: 0;
        }

        .content-width {
            flex: 1;
        }

        .company-width {
            width: 135px;
            flex-shrink: 0;
            padding: 0 10px;
        }

        .sname-width {
            width: 100px;
            flex-shrink: 0;
            padding: 0 10px;
        }

        .date-width {
            width: 100px;
            flex-shrink: 0;
        }
    }

    .level-sname {
        position: relative;
        padding-right: 52px !important;
        width: fit-content;
        max-width: 100%;
    }

    .level-text {
        position: absolute;
        right: 0;
        top: -6px;
        font-size: 42px;
    }

    // 状态
    .is-read,
    .is-unread {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 3px;
    }

    .is-read {
        background-color: #71dc75;
    }

    .is-unread {
        background-color: #ff0000;
    }

    .readed-color {
        color: #c9c9c9;
    }

    .unread-color {
        color: #e02020;
    }

    .shenji-color {
        color: #60ADF9;
        transform: scale(1.2);
        margin-left: 4px;
    }

    .shouli-color {
        // color: #72aa2c;
        color: #66C239;
        transform: scale(1.2);
        margin-left: 4px;
    }
}

.tootip-content {
    h6,
    p {
        line-height: 20px;
    }
}

.wenhao {
    width: 14px;
    height: 14px;
    color: #fff !important;
    vertical-align: text-bottom !important;
    margin-left: 6px !important;
}

.sp-input-home {
    /deep/.el-input__inner {
        padding-right: 65px !important;
    }
}

.sub-container {
    display: flex;
    flex-wrap: wrap;
    .sub-item {
        width: calc(~"(100% - 80px) / 5");
        // box-shadow: 0 0 10px 0 rgba(31, 59, 74, 0.1);
        border: 1px solid #ebeef5;
        border-radius: 3px;
        margin-bottom: 20px;
        margin-right: 20px;
        cursor: pointer;
        position: relative;

        &:hover {
            border: none;
            box-shadow: 0px 0px 10px 0px rgba(31, 59, 74, 0.1);
        }
    }

    .sub-item:nth-of-type(5n) {
        margin-right: 0;
    }

    .sub-tips-icon {
        position: absolute;
        left: 5px;
        top: 5px;
    }

    .sub-icon {
        text-align: center;
    }

    .sub-img {
        width: 50%;
        max-width: 60px;
        height: 100%;
        vertical-align: middle;
        margin: 20px auto 0;
    }

    .sub-text {
        font-size: 12px;
        line-height: 18px;
        color: #666;
        text-align: center;
        padding: 12px;
    }
}
</style>
